
{/* eslint-disable max-len */}
const SwapIcon = (): JSX.Element => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M31.4958 21.2155H3.53549C3.3587 21.2155 3.21406 21.3602 3.21406 21.537V23.9477C3.21406 24.1245 3.3587 24.2691 3.53549 24.2691H27.8516L22.0538 31.6218C21.8891 31.8307 22.0377 32.1441 22.3069 32.1441H25.2199C25.4167 32.1441 25.6016 32.0557 25.7261 31.899L32.5083 23.2968C33.1712 22.453 32.5725 21.2155 31.4958 21.2155ZM32.4641 11.7334H8.14799L13.9458 4.38072C14.1105 4.17179 13.9618 3.8584 13.6926 3.8584H10.7797C10.5828 3.8584 10.398 3.94679 10.2734 4.10349L3.49129 12.7057C2.82835 13.5495 3.42701 14.787 4.49978 14.787H32.4641C32.6409 14.787 32.7855 14.6423 32.7855 14.4655V12.0548C32.7855 11.878 32.6409 11.7334 32.4641 11.7334Z" fill="#626368"/>
  </svg>
);

export default SwapIcon;
